import { useQuery } from '@tanstack/react-query';
import * as Routes from 'modules/routes';
import axios from 'axios';
import { TagType, IPaginationInfo } from '../types';

type UseTagTypes = {
  programId: number,
  page: number,
  perPage: number,
  setTags: (tags: TagType[]) => void,
};

const useTags = ({ programId, page, perPage, setTags }: UseTagTypes) => {
  const path = Routes.plato_api_program_tags_tags_path({
    page,
    per_page: perPage,
    program_id: programId,
  });

  const query = useQuery(['correlation_tags', programId, page, perPage], () => (
    axios
      .get<{ tags: TagType[], pagination: IPaginationInfo }>(path)
      .then((res) => {
        setTags(res.data.tags);

        return res.data;
      })
      // eslint-disable-next-line no-console
      .catch(err => console.error(err))
  ), { staleTime: Infinity });

  return { ...query, data: query.data || {} as { tags: TagType[], pagination: IPaginationInfo } };
};

export default useTags;
